import React from 'react';
import './SegmentedControl.scss';

interface SegmentedControlProps<T extends string> {
  label: string;
  options: Array<{ value: T; label: string }>;
  value: T;
  onChange: (value: T) => void;
  /** `light` sits on a white card, `dark` on the navy hero band. */
  variant?: 'light' | 'dark';
}

function SegmentedControl<T extends string>({
  label,
  options,
  value,
  onChange,
  variant = 'light',
}: SegmentedControlProps<T>) {
  return (
    <div role="group" aria-label={label} className={`SegmentedControl SegmentedControl--${variant}`}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          aria-pressed={o.value === value}
          className={`SegmentedControl__pill${o.value === value ? ' SegmentedControl__pill--active' : ''}`}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

export default SegmentedControl;
